import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { RecordLabel } from '@common/types/record-label/record-label';
import { Action } from 'redux';
import { RecordLabelRelation } from '@services/record-labels/types/record-label-relation';
import { NewRecordLabelRelation } from '@services/record-labels/types/new-record-label-relation';
import { Operator } from '@services/record-labels/types/operator';
import InviteExistingArtistRequest from '@common/types/record-label/invite-existing-artist-request';
import InviteOperatorRequest from '@common/types/record-label/invite-operator-request';
import { Product } from '@services/product/types/product';
import { Price } from '@common/types/price/price';
import { OnboardingLabelArtist } from './state';
import { RecordLabelSubscriptionType } from '@services/subscription/types/record-label-subcription';
import SimpleArtist from '@common/types/artist/simple-artist';

export class SetActiveLabel implements Action {
  readonly type = actions.SET_ACTIVE_LABEL;

  constructor(public label: RecordLabel) {}
}

export class GetRecordLabels implements LoadingAction {
  readonly type = actions.GET_RECORD_LABELS;
  readonly isLoading = true;
}

export class GetRecordLabelsSuccess implements LoadingAction {
  readonly type = actions.GET_RECORD_LABELS_SUCCESS;
  readonly isLoading = false;

  constructor(public list: RecordLabel[]) {}
}

export class GetRecordLabelsError implements ErrorAction {
  readonly type = actions.GET_RECORD_LABELS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetArtistRecordLabels implements LoadingAction {
  readonly type = actions.GET_ARTIST_RECORD_LABELS;
  readonly isLoading = true;

  constructor(public artistId: string) {}
}

export class GetArtistRecordLabelsSuccess implements LoadingAction {
  readonly type = actions.GET_ARTIST_RECORD_LABELS_SUCCESS;
  readonly isLoading = false;

  constructor(public list: RecordLabelRelation[]) {}
}

export class GetArtistRecordLabelsError implements ErrorAction {
  readonly type = actions.GET_ARTIST_RECORD_LABELS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListRecordLabelArtists implements LoadingAction {
  readonly type = actions.LIST_RECORD_LABEL_ARTIST;
  readonly isLoading = true;

  constructor(public recordLabelId: string) {}
}

export class ListRecordLabelArtistsSuccess implements LoadingAction {
  readonly type = actions.LIST_RECORD_LABEL_ARTIST_SUCCESS;
  readonly isLoading = false;

  constructor(
    public recordLabelId: string,
    public list: RecordLabelRelation[]
  ) {}
}

export class ListRecordLabelArtistsError implements ErrorAction {
  readonly type = actions.LIST_RECORD_LABEL_ARTIST_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateRecordLabel implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL;
  readonly isLoading = true;

  constructor(
    public rosterName: string,
    public merchOwnership: number,
    public recordingOwnership: number,
    public artists: SimpleArtist[]
  ) {}
}

export class CreateRecordLabelSuccess implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(
    public recordLabel: RecordLabel,
    public artistsToAttach: SimpleArtist[],
    public rosterName: string
  ) {}
}

export class CreateRecordLabelError implements ErrorAction {
  readonly type = actions.CREATE_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateRecordLabelName implements Action {
  readonly type = actions.UPDATE_RECORD_LABEL_NAME;

  constructor(public recordLabelId: string, public name: string) {}
}
export class UpdateRecordLabelArtistCount implements Action {
  readonly type = actions.UPDATE_RECORD_LABEL_ARTIST_COUNT;

  constructor(public recordLabelId: string) {}
}

export class DowngradeRecordLabel implements LoadingAction {
  readonly type = actions.DOWNGRADE_RECORD_LABEL;
  readonly isLoading = true;

  constructor(
    public recordLabelId: string,
    public subscriptionId: string,
    public artistIds: string[]
  ) {}
}

export class DowngradeRecordLabelSuccess implements LoadingAction {
  readonly type = actions.DOWNGRADE_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabelId: string, public subscriptionId: string) {}
}

export class DowngradeRecordLabelError implements ErrorAction {
  readonly type = actions.DOWNGRADE_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class UpdateRecordLabel implements LoadingAction {
  readonly type = actions.UPDATE_RECORD_LABEL;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public recordLabel: RecordLabel,
    public artists?: SimpleArtist[],
    public rosterName?: string
  ) {}
}

export class UpdateRecordLabelSuccess implements LoadingAction {
  readonly type = actions.UPDATE_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(
    public recordLabel: RecordLabel,
    public artistsToAttach?: SimpleArtist[],
    public rosterName?: string
  ) {}
}

export class UpdateRecordLabelError implements ErrorAction {
  readonly type = actions.UPDATE_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateRecordLabelRelation implements LoadingAction {
  readonly type = actions.UPDATE_RECORD_LABEL_RELATION;
  readonly isLoading = true;

  constructor(public recordLabelRelation: RecordLabelRelation) {}
}

export class UpdateRecordLabelRelationSuccess implements LoadingAction {
  readonly type = actions.UPDATE_RECORD_LABEL_RELATION_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabelRelation: RecordLabelRelation) {}
}

export class UpdateRecordLabelRelationError implements ErrorAction {
  readonly type = actions.UPDATE_RECORD_LABEL_RELATION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class DeleteRecordLabel implements Action {
  readonly type = actions.DELETE_RECORD_LABEL;

  constructor(public recordLabelId: string) {}
}

export class DeleteRecordLabelSuccess implements LoadingAction {
  readonly type = actions.DELETE_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabelId: string) {}
}

export class DeleteRecordLabelError implements ErrorAction {
  readonly type = actions.DELETE_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class AttachToRecordLabel implements LoadingAction {
  readonly type = actions.ATTACH_TO_RECORD_LABEL;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public relation: NewRecordLabelRelation) {}
}

export class AttachToRecordLabelSuccess implements LoadingAction {
  readonly type = actions.ATTACH_TO_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(public relation: RecordLabelRelation) {}
}

export class AttachToRecordLabelError implements ErrorAction {
  readonly type = actions.ATTACH_TO_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RemoveFromRecordLabel implements LoadingAction {
  readonly type = actions.REMOVE_FROM_RECORD_LABEL;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public relation: RecordLabelRelation) {}
}

export class RemoveFromRecordLabelSuccess implements LoadingAction {
  readonly type = actions.REMOVE_FROM_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(public relation: RecordLabelRelation) {}
}

export class RemoveFromRecordLabelError implements ErrorAction {
  readonly type = actions.REMOVE_FROM_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RestoreRecordLabel implements Action {
  readonly type = actions.RESTORE_RECORD_LABEL;

  constructor(public recordLabelId: string, public artists: string[]) {}
}

export class RestoreRecordLabelSuccess implements LoadingAction {
  readonly type = actions.RESTORE_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabelId: string) {}
}

export class RestoreRecordLabelError implements ErrorAction {
  readonly type = actions.RESTORE_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateRelationSplit implements Action {
  readonly type = actions.UPDATE_RECORD_LABEL_RELATION_SPLIT;

  constructor(public relation: RecordLabelRelation, public split: number) {}
}

export class CreateRecordLabelOnboarding implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_ONBOARDING;
  readonly isLoading = true;

  constructor(public recordLabelName: string) {}
}

export class CreateRecordLabelOnboardingSuccess implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_ONBOARDING_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabel: RecordLabel) {}
}

export class CreateRecordLabelOnboardingError implements ErrorAction {
  readonly type = actions.CREATE_RECORD_LABEL_ONBOARDING_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListRecordLabelOperators implements LoadingAction {
  readonly type = actions.LIST_RECORD_LABEL_OPERATORS;
  readonly isLoading = true;

  constructor(public recordLabelId: string) {}
}

export class ListRecordLabelOperatorsSuccess implements LoadingAction {
  readonly type = actions.LIST_RECORD_LABEL_OPERATORS_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabelId: string, public list: Operator[]) {}
}

export class ListRecordLabelOperatorsError implements ErrorAction {
  readonly type = actions.LIST_RECORD_LABEL_OPERATORS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateRecordLabelOperator implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_OPERATOR;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public recordLabelId: string,
    public userName: string,
    public userId: string
  ) {}
}

export class CreateRecordLabelOperatorSuccess implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_OPERATOR_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public recordLabelId: string, public operator: Operator) {}
}

export class CreateRecordLabelOperatorError implements ErrorAction {
  readonly type = actions.CREATE_RECORD_LABEL_OPERATOR_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RemoveOperatorFromRecordLabel implements LoadingAction {
  readonly type = actions.REMOVE_OPERATOR_FROM_RECORD_LABEL;
  readonly isLoading = true;

  constructor(public recordLabelId: string, public operatorId: string) {}
}

export class RemoveOperatorFromRecordLabelSuccess implements LoadingAction {
  readonly type = actions.REMOVE_OPERATOR_FROM_RECORD_LABEL_SUCCESS;
  readonly isLoading = false;

  constructor(public recordLabelId: string, public operatorId: string) {}
}

export class RemoveOperatorFromRecordLabelError implements ErrorAction {
  readonly type = actions.REMOVE_OPERATOR_FROM_RECORD_LABEL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateRecordLabelInvite implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_INVITE;
  readonly isLoading = false;

  constructor(
    public recordLabelId: string,
    public invite: InviteExistingArtistRequest
  ) {}
}

export class CreateRecordLabelInviteSuccess implements LoadingAction {
  readonly type = actions.CREATE_RECORD_LABEL_INVITE_SUCCESS;
  readonly isLoading = false;
}

export class CreateRecordLabelInviteError implements ErrorAction {
  readonly type = actions.CREATE_RECORD_LABEL_INVITE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateOperatorInvite implements LoadingAction {
  readonly type = actions.CREATE_OPERATOR_INVITE;
  readonly isLoading = false;

  constructor(
    public recordLabelId: string,
    public invite: InviteOperatorRequest
  ) {}
}

export class CreateOperatorInviteSuccess implements LoadingAction {
  readonly type = actions.CREATE_OPERATOR_INVITE_SUCCESS;
  readonly isLoading = false;
}

export class CreateOperatorInviteError implements ErrorAction {
  readonly type = actions.CREATE_OPERATOR_INVITE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class StartLabelOnboarding implements Action {
  readonly type = actions.LABEL_ONBOARDING_START;
}

export class StartLabelOnboardingUpgrade implements Action {
  readonly type = actions.LABEL_ONBOARDING_UPGRADE;

  constructor(public recordLabel: RecordLabel) {}
}

export class LabelOnboardingSelectPlan implements Action {
  readonly type = actions.LABEL_ONBOARDING_SELECT_PLAN;

  constructor(public product: Product, public price: Price) {}
}

export class LabelOnboardingUpdateName implements Action {
  readonly type = actions.LABEL_ONBOARDING_UPDATE_NAME;

  constructor(public name: string) {}
}

export class LabelOnboardingAddArtist implements Action {
  readonly type = actions.LABEL_ONBOARDING_ADD_ARTIST;

  constructor(public artist: OnboardingLabelArtist) {}
}

export class LabelOnboardingRemoveArtist implements Action {
  readonly type = actions.LABEL_ONBOARDING_REMOVE_ARTIST;

  constructor(public contact: string) {}
}

export class LabelOnboardingSuccess implements Action {
  readonly type = actions.LABEL_ONBOARDING_SUCCESS;

  constructor(
    public recordLabel: RecordLabel,
    public plan: RecordLabelSubscriptionType,
    public redirect: boolean = false
  ) {}
}

export type RecordLabelsActions =
  | SetActiveLabel
  | GetRecordLabels
  | GetRecordLabelsSuccess
  | GetRecordLabelsError
  | UpdateRecordLabelName
  | UpdateRecordLabelArtistCount
  | UpdateRecordLabel
  | UpdateRecordLabelSuccess
  | UpdateRecordLabelError
  | DeleteRecordLabel
  | DeleteRecordLabelSuccess
  | DeleteRecordLabelError
  | AttachToRecordLabel
  | AttachToRecordLabelSuccess
  | AttachToRecordLabelError
  | RemoveFromRecordLabel
  | RemoveFromRecordLabelSuccess
  | RemoveFromRecordLabelError
  | RestoreRecordLabel
  | RestoreRecordLabelSuccess
  | RestoreRecordLabelError
  | CreateRecordLabel
  | CreateRecordLabelSuccess
  | CreateRecordLabelError
  | ListRecordLabelArtists
  | ListRecordLabelArtistsSuccess
  | ListRecordLabelArtistsError
  | UpdateRelationSplit
  | UpdateRecordLabelRelation
  | UpdateRecordLabelRelationSuccess
  | UpdateRecordLabelRelationError
  | GetArtistRecordLabels
  | GetArtistRecordLabelsSuccess
  | GetArtistRecordLabelsError
  | ListRecordLabelOperators
  | ListRecordLabelOperatorsSuccess
  | ListRecordLabelOperatorsError
  | CreateRecordLabelOperator
  | CreateRecordLabelOperatorSuccess
  | CreateRecordLabelOperatorError
  | RemoveOperatorFromRecordLabel
  | RemoveOperatorFromRecordLabelSuccess
  | RemoveOperatorFromRecordLabelError
  | CreateRecordLabelInvite
  | CreateRecordLabelInviteSuccess
  | CreateRecordLabelInviteError
  | CreateOperatorInvite
  | CreateOperatorInviteSuccess
  | CreateOperatorInviteError
  | CreateRecordLabelOnboarding
  | CreateRecordLabelOnboardingSuccess
  | CreateRecordLabelOnboardingError
  | StartLabelOnboarding
  | StartLabelOnboardingUpgrade
  | LabelOnboardingSelectPlan
  | LabelOnboardingUpdateName
  | LabelOnboardingAddArtist
  | LabelOnboardingRemoveArtist
  | LabelOnboardingSuccess
  | DowngradeRecordLabel
  | DowngradeRecordLabelSuccess
  | DowngradeRecordLabelError;
